import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectNotSelectedVisibleNodeIds } from 'components/Graph/model/selectors/selectNotSelectedVisibleNodeIds';
import { clearSharedView } from '../helpers/clearSharedView';
import { makeUpdateNodesVisibility } from '../helpers/updateNodesVisibility';
import { selectPathLookupApplied } from '../model/selectors/graphMetadata/selectPathLookupApplied';

export const hideNotSelectedNodes: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    if (selectPathLookupApplied(cmdContext.getState())) {
      stumble('Hiding not selected nodes is not allowed for Path-lookup');
      return;
    }
    cmdContext.updateState(clearSharedView);
    const nodeIdsToHide = Array.from(
      selectNotSelectedVisibleNodeIds(cmdContext.getState()),
    );
    const { peekingAtHiddenNodes } = cmdContext.getState();
    dispatch(performUndoableAction, {
      undo: makeUpdateNodesVisibility(
        cmdContext.updateState,
        nodeIdsToHide,
        true,
        peekingAtHiddenNodes,
      ),
      redo: makeUpdateNodesVisibility(
        cmdContext.updateState,
        nodeIdsToHide,
        false,
        peekingAtHiddenNodes,
      ),
    });
  };
